// extracted by mini-css-extract-plugin
module.exports = {"haztuhorarioPreview":"home-module--haztuhorarioPreview--2pqO9","gymsysPreview":"home-module--gymsysPreview--imDm_","tapPreview":"home-module--tapPreview--2ygHY"};